import { render, staticRenderFns } from "./AppBlocked.vue?vue&type=template&id=a1ba1796&scoped=true"
import script from "./AppBlocked.vue?vue&type=script&lang=js"
export * from "./AppBlocked.vue?vue&type=script&lang=js"
import style0 from "./AppBlocked.vue?vue&type=style&index=0&id=a1ba1796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ba1796",
  null
  
)

export default component.exports